const S3Url = "https://westpac-bucket.s3.ap-southeast-2.amazonaws.com/glossary/"

export default S3Url